import React, { createContext, useContext, useState } from "react";

const HeaderContext = createContext();

export const HeaderProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [groqResponse, setGroqResponse] = useState("");
  const [conversation, setConversation] = useState([]);
  const [groqLoading, setGroqLoading] = useState(false);
  const [error, setError] = useState(null);
  const [isMemoryOpen, setIsMemoryOpen] = useState(false);

  // New: location (object: name, lat, lon) and groqContext (string)
  const [location, setLocationState] = useState({ name: "", lat: undefined, lon: undefined });
  const [groqContext, setGroqContext] = useState("");

  // Wrap setLocation to add debugging
  const setLocation = React.useCallback((newLocation) => {
    console.log("[DEBUG] HeaderContext setLocation called with:", newLocation);
    setLocationState(newLocation);
  }, []);

  // Field notes: single object at a time
  const [fieldNotes, setFieldNotes] = useState(null);

  return (
    <HeaderContext.Provider
      value={{
        user, setUser,
        email, setEmail,
        password, setPassword,
        searchTerm, setSearchTerm,
        groqResponse, setGroqResponse,
        conversation, setConversation,
        groqLoading, setGroqLoading,
        error, setError,
        isMemoryOpen, setIsMemoryOpen,
        location, setLocation,
        groqContext, setGroqContext,
        fieldNotes, setFieldNotes,
      }}
    >
      {children}
    </HeaderContext.Provider>
  );
};

export const useHeaderContext = () => useContext(HeaderContext);
